import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc658'];

export const formatCurrency = (amount) =>
  `$${(amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const KPI_STYLES = {
  blue: { card: 'border-blue-200 shadow-sm', value: 'text-2xl font-bold text-blue-600 mt-1', iconWrap: 'p-3 bg-blue-100 rounded-full', icon: 'w-6 h-6 text-blue-600' },
  green: { card: 'border-green-200 shadow-sm', value: 'text-2xl font-bold text-green-600 mt-1', iconWrap: 'p-3 bg-green-100 rounded-full', icon: 'w-6 h-6 text-green-600' },
  amber: { card: 'border-amber-200 shadow-sm', value: 'text-2xl font-bold text-amber-600 mt-1', iconWrap: 'p-3 bg-amber-100 rounded-full', icon: 'w-6 h-6 text-amber-600' },
  purple: { card: 'border-purple-200 shadow-sm', value: 'text-2xl font-bold text-purple-600 mt-1', iconWrap: 'p-3 bg-purple-100 rounded-full', icon: 'w-6 h-6 text-purple-600' },
  emerald: { card: 'border-emerald-200 shadow-sm', value: 'text-2xl font-bold text-emerald-600 mt-1', iconWrap: 'p-3 bg-emerald-100 rounded-full', icon: 'w-6 h-6 text-emerald-600' },
  red: { card: 'border-red-200 shadow-sm', value: 'text-2xl font-bold text-red-600 mt-1', iconWrap: 'p-3 bg-red-100 rounded-full', icon: 'w-6 h-6 text-red-600' },
};

export const KPICard = ({ title, value, subtitle, icon: Icon, color = 'blue', trend }) => {
  const s = KPI_STYLES[color] || KPI_STYLES.blue;
  return (
    <Card className={s.card}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide">{title}</p>
            <p className={s.value}>{value}</p>
            {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
            {trend && (
              <p className={`text-xs mt-1 ${trend > 0 ? 'text-green-500' : 'text-red-500'}`}>
                {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}% vs last period
              </p>
            )}
          </div>
          <div className={s.iconWrap}>
            <Icon className={s.icon} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const ALIGN = { left: 'text-left', right: 'text-right', center: 'text-center' };

export const DataTable = ({ columns, data, onRowClick }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead className="bg-gray-50 border-b">
        <tr>
          {columns.map((col, idx) => (
            <th key={idx} className={`p-3 ${ALIGN[col.align || 'left']} font-semibold text-gray-700`}>
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="p-8 text-center text-gray-500">
              No data available
            </td>
          </tr>
        ) : (
          data.map((row, rowIdx) => (
            <tr
              key={rowIdx}
              className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer"
              onClick={() => onRowClick && onRowClick(row)}
            >
              {columns.map((col, colIdx) => (
                <td key={colIdx} className={`p-3 ${ALIGN[col.align || 'left']}`}>
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);
